import { NewToast } from './ToastContext';

export const RECONNECT_TOAST: NewToast = {
  message:
    'Misslyckades att återansluta till servern. Kontrollera din internetanslutning.',
  type: 'error',
  stick: true,
};

export const DISCONNECT_TOAST: NewToast = {
  message: 'Tappade anslutningen till servern. Försöker återansluta...',
  type: 'warning',
  stick: false,
};

export const CONNECTED_TOAST: NewToast = {
  type: 'success',
  message: 'Ansluten till servern igen. Dina ändringar har uppdaterats.',
  clearToasts: true,
};

export const BOOTSTRAP_ERROR_TOAST: NewToast = {
  message: 'Misslyckades att ladda projektet. Prova att ladda om sidan.',
  type: 'error',
  stick: true,
};
